import React from 'react';
import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifButton,
  MotifIcon,
} from '@ey-xd/motif-react';
import { alertIcWarning24px } from '@ey-xd/motif-react/assets/icons';
import { useRecoilState } from 'recoil';
import { Modal_Trigger_State } from '@recoil/recoil';
import { useNavigate } from 'react-router-dom';
import { BUTTON_TITLE, ECM } from '@constants/commonConstants';
import { BodyContent, HeaderWrapper, ParagraphStyle } from '@organisms/modals/styles/modalStyles';

const ExitConformationModal = ({ modalNavigate }) => {
  const navigate = useNavigate();

  const [showWarningModal, setShowWarningModal] = useRecoilState(Modal_Trigger_State);

  const closeWarningModal = () => {
    setShowWarningModal(false);
    navigate(modalNavigate);
  };

  const closeWarningModalByCancel = () => {
    setShowWarningModal(false);
  };

  const Header = ({ children }) => <HeaderWrapper>{children}</HeaderWrapper>;
  const bodyContent = (
    <BodyContent>
      <p>{ECM.DESCRIPTON}</p>
    </BodyContent>
  );
  const headerTitle = <span style={{ marginLeft: 11, fontSize: 16 }}>{ECM.HEADER_TITLE}</span>;

  return (
    <MotifModal
      variant="alt"
      show={showWarningModal}
      onClose={closeWarningModalByCancel}
      style={{ width: '485px' }}
      focusTrapOptions={{
        initialFocus: false,
      }}
    >
      <MotifModalHeader closeModalButton={true}>
        <Header>
          <MotifIcon style={{ color: '#FF9831', lineHeight: 1 }} src={alertIcWarning24px} />
          {headerTitle}
        </Header>
      </MotifModalHeader>
      <MotifModalBody>
        <ParagraphStyle> {bodyContent}</ParagraphStyle>
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton variant="warn" type="button" onClick={closeWarningModal}>
          {ECM.EXIT_BUTTON_TITLE}
        </MotifButton>
        <MotifButton variant="secondary" type="button" onClick={closeWarningModalByCancel}>
          {BUTTON_TITLE.CANCEL}
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
};
export default ExitConformationModal;
